import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';
// ===============================================
// 🔥 SELLER DOPING ACTIONS
// ===============================================

// ✅ Doping qiymətlərini əldə et
export const get_doping_prices = createAsyncThunk(
    'doping/get_doping_prices',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get('/doping-prices');
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Qiymətlər əldə edilmədi' });
        }
    }
);

export const get_seller_doping_packages = createAsyncThunk(
    'doping/get_seller_doping_packages',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/seller/doping/packages')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping paketleri yuklenmedi' })
        }
    }
)

// ✅ Doping əlavə et
export const add_doping = createAsyncThunk(
    'doping/add_doping',
    async ({ productId, dopingType, duration, packageId }, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.post('/doping-add', { 
                productId, 
                dopingType, 
                duration,
                packageId
            });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping əlavə edilmədi' });
        }
    }
);

// ✅ Doping yenilə
export const update_doping = createAsyncThunk(
    'doping/update_doping',
    async ({ dopingId, dopingType, duration }, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.put('/doping-update', { 
                dopingId, 
                dopingType, 
                duration 
            });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping yenilənmədi' });
        }
    }
);

// ✅ Doping ləğv et
export const cancel_doping = createAsyncThunk(
    'doping/cancel_doping',
    async (dopingId, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.post('/doping-cancel', { dopingId });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping ləğv edilmədi' });
        }
    }
);

// ✅ Seller-in doping tarixçəsi
export const get_seller_dopings = createAsyncThunk(
    'doping/get_seller_dopings',
    async ({ page = 1, limit = 10, status }, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get(`/seller/dopings?page=${page}&limit=${limit}${status ? `&status=${status}` : ''}`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Tarixçə əldə edilmədi' });
        }
    }
);

// ✅ Doping statistikası
export const get_doping_stats = createAsyncThunk(
    'doping/get_doping_stats',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get('/seller/doping-stats');
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Statistika əldə edilmədi' });
        }
    }
);

// ===============================================
// 🔥 CLIENT DOPING ACTIONS
// ===============================================

// ✅ Aktiv dopingli məhsullar (Client üçün)
export const get_active_dopings = createAsyncThunk(
    'doping/get_active_dopings',
    async ({ dopingType, limit = 20 }, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get(`/active-dopings?${dopingType ? `dopingType=${dopingType}&` : ''}limit=${limit}`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Aktiv dopinqlər əldə edilmədi' });
        }
    }
);

// ✅ Məhsulun aktiv dopinqi
export const get_product_active_doping = createAsyncThunk(
    'doping/get_product_active_doping',
    async (productId, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get(`/product/${productId}/doping`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məhsul dopinqi tapılmadı' });
        }
    }
);

// ✅ Kateqoriya üzrə dopingli məhsullar
export const get_category_doped_products = createAsyncThunk(
    'doping/get_category_doped_products',
    async ({ category, limit = 10 }, { rejectWithValue, fulfillWithValue, getState }) => {
        try {
            const { data } = await api.get(`/active-dopings?dopingType=anasayfa_vitrini&limit=${limit}`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məhsullar əldə edilmədi' });
        }
    }
);

// ===============================================
// 🔥 REDUX SLICE
// ===============================================

export const dopingReducer = createSlice({
    name: 'doping',
    initialState: {
        // Loading states
        loader: false,
        dopingLoader: false,
        
        // Seller data
        dopingPrices: null,
        dopingPackages: [],
        sellerDopings: [],
        dopingStats: null,
        sellerDopingsPagination: {
            page: 1,
            limit: 5,
            total: 0,
            totalPages: 0,
            hasNextPage: false,
            hasPrevPage: false
        },
        totalDopings: 0,
        
        // Client data
        activeDopings: [],
        searchDopings: [],
        dailyDeals: [],
        homepageFeatured: [],
        currentProductDoping: null,
        
        // Messages
        successMessage: '',
        errorMessage: ''
    },
    
    reducers: {
        messageClear: (state) => {
            state.errorMessage = '';
            state.successMessage = '';
        },
        
        clearError: (state) => {
            state.errorMessage = '';
        },
        
        clearCurrentProductDoping: (state) => {
            state.currentProductDoping = null;
        }
    },
    
    extraReducers: (builder) => {
        builder
            // ===============================================
            // Get Doping Prices
            // ===============================================
            .addCase(get_doping_prices.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_doping_prices.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.dopingPrices = payload.prices;
            })
            .addCase(get_doping_prices.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || payload?.error || 'Qiymətlər əldə edilmədi';
            })
            .addCase(get_seller_doping_packages.fulfilled, (state, { payload }) => {
                state.dopingPackages = payload.packages || [];
            })
            
            // ===============================================
            // Add Doping
            // ===============================================
            .addCase(add_doping.pending, (state) => {
                state.dopingLoader = true;
            })
            .addCase(add_doping.fulfilled, (state, { payload }) => {
                state.dopingLoader = false;
                state.successMessage = payload.message || 'Doping uğurla əlavə edildi!';
            })
            .addCase(add_doping.rejected, (state, { payload }) => {
                state.dopingLoader = false;
                state.errorMessage = payload?.message || payload?.error || 'Doping əlavə edilmədi';
            })
            
            // ===============================================
            // Update Doping
            // ===============================================
            .addCase(update_doping.pending, (state) => {
                state.dopingLoader = true;
            })
            .addCase(update_doping.fulfilled, (state, { payload }) => {
                state.dopingLoader = false;
                state.successMessage = payload.message || 'Doping uğurla yeniləndi!';
            })
            .addCase(update_doping.rejected, (state, { payload }) => {
                state.dopingLoader = false;
                state.errorMessage = payload?.message || payload?.error || 'Doping yenilənmədi';
            })
            
            // ===============================================
            // Cancel Doping
            // ===============================================
            .addCase(cancel_doping.pending, (state) => {
                state.dopingLoader = true;
            })
            .addCase(cancel_doping.fulfilled, (state, { payload }) => {
                state.dopingLoader = false;
                state.successMessage = payload.message || 'Doping ləğv edildi!';
            })
            .addCase(cancel_doping.rejected, (state, { payload }) => {
                state.dopingLoader = false;
                state.errorMessage = payload?.message || payload?.error || 'Doping ləğv edilmədi';
            })
            
            // ===============================================
            // Get Seller Dopings
            // ===============================================
            .addCase(get_seller_dopings.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_seller_dopings.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.sellerDopings = payload.dopings || payload.data || [];
                const page = Number(payload.page || payload.pagination?.page || 1);
                const limit = Number(payload.limit || payload.pagination?.limit || 5);
                const total = Number(payload.total || payload.pagination?.total || state.sellerDopings.length);
                const totalPages = Number(payload.pages || payload.pagination?.totalPages || Math.ceil(total / Math.max(limit, 1)));
                state.totalDopings = total;
                state.sellerDopingsPagination = {
                    page,
                    limit,
                    total,
                    totalPages,
                    hasNextPage: payload.pagination?.hasNextPage ?? page < totalPages,
                    hasPrevPage: payload.pagination?.hasPrevPage ?? page > 1
                };
            })
            .addCase(get_seller_dopings.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || payload?.error || 'Tarixçə əldə edilmədi';
            })
            
            // ===============================================
            // Get Doping Stats
            // ===============================================
            .addCase(get_doping_stats.fulfilled, (state, { payload }) => {
                state.dopingStats = payload;
            })
            
            // ===============================================
            // Get Active Dopings (CLIENT)
            // ===============================================
            .addCase(get_active_dopings.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_active_dopings.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.activeDopings = payload.dopings;
                
                state.searchDopings = payload.dopings.filter(
                    d => ['arama_vitrini', 'search_featured'].includes(d.dopingType)
                );
                
                state.dailyDeals = payload.dopings.filter(
                    d => ['gunun_firsati', 'daily_deal'].includes(d.dopingType)
                );
                
                state.homepageFeatured = payload.dopings.filter(
                    d => ['anasayfa_vitrini', 'home_featured'].includes(d.dopingType)
                );
            })
            .addCase(get_active_dopings.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || payload?.error || 'Aktiv dopinqlər əldə edilmədi';
            })
            
            // ===============================================
            // Get Product Active Doping
            // ===============================================
            .addCase(get_product_active_doping.fulfilled, (state, { payload }) => {
                state.currentProductDoping = payload;
            })
            .addCase(get_product_active_doping.rejected, (state) => {
                state.currentProductDoping = null;
            })
            
            // ===============================================
            // Get Category Doped Products
            // ===============================================
            .addCase(get_category_doped_products.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_category_doped_products.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.homepageFeatured = payload.dopings;
            })
            .addCase(get_category_doped_products.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || payload?.error || 'Məhsullar əldə edilmədi';
            });
    }
});

export const { 
    messageClear,
    clearError, 
    clearCurrentProductDoping 
} = dopingReducer.actions;

export default dopingReducer.reducer;
